import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export default function ASYAModules() {
  const { t } = useTranslation();
  const modules = t('asya_erp.modules', { returnObjects: true }) as Array<{ icon: string; title: string; description: string }>;

  return (
    <section id="asya-erp" className="py-24 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <span className="inline-block px-3 py-1 bg-primary-container/10 text-primary-container text-[12px] font-bold uppercase tracking-wider rounded-full mb-4">
            {t('asya_erp.badge')}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-4">{t('asya_erp.title')}</h2>
          <p className="text-lg text-on-surface-variant font-medium mb-4">{t('asya_erp.subtitle')}</p>
          <p className="text-on-surface-variant max-w-2xl leading-relaxed">{t('asya_erp.description')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {modules.map((mod, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.05 }}
              className="flex items-start gap-4 p-5 bg-surface-container-low border border-outline-variant rounded-xl hover:border-primary-container transition-all"
            >
              <span className="text-3xl shrink-0">{mod.icon}</span>
              <div>
                <h3 className="font-bold text-on-surface mb-1">{mod.title}</h3>
                <p className="text-on-surface-variant text-sm">{mod.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
